<nav class="navbar navbar-expand-lg px-0">
  <div class="container-page d-flex align-items-center">
    <span id="btn" [class.menu-closed]="toggleSide" (click)="toggleSidebar()"><span
        class="material-icons">menu_open</span></span>






    <!--
    <div aria-label="breadcrumb" class="ms-4">
      <ol class="breadcrumb mb-0">
        <li class="breadcrumb-item"><a>Home</a></li>
        <li class="breadcrumb-item"><a>Requests</a></li>
        <li class="breadcrumb-item active">Call for Vocal and Choral Ensembles</li>
      </ol>
    </div>
-->
    <div class="ms-auto profile mx-4" (click)="profile()" [class.active-profile]="profileMenu">
      <img src="{{ imgUrl }}{{ User.image }}">
      <div class="profile-info me-3">
        <h5>{{User.email}}</h5>
        <small>{{ User.name }}</small>
      </div>
      <div class="arrows">
        <span class="material-icons up">expand_more</span>
        <span class="material-icons">expand_less</span>
      </div>
    </div>
    <div class="profile-box" [class.openedProfile]="profileMenu">
      <div class="profile-item">
        <div class="text">
          <span class="admin">{{ User.name }}</span>
          <p>{{User.email}}</p>
        </div>
      </div>
      <div class="profile-item" [routerLink]="['/users/edit/admins/profile/'+User.id]">
        <div class="text">
          <span>Edit Profile</span>
        </div>
      </div>
      <div class="profile-item"  [routerLink]="['/users/edit/admins/password/'+User.id]">
        <div class="text">
          <span>Change Password</span>
        </div>
      </div>
      <div class="profile-item">
        <div class="text logout" data-bs-toggle="modal" data-bs-target="#exampleModal">
          <mat-icon class="change">logout</mat-icon>
          <span class="red ms-2">
            Log Out
          </span>
        </div>
      </div>

    </div>
    <div class="notification disabled_iteam ms-3">
      <div class="icon-button" (click)="openNotifi()" [class.active-notification]="notifiMenu">
        <span class="material-icons">notifications</span>
        <span class="icon-button__badge"></span>

      </div>
      <div class="notifi-box" id="box" [class.openenotifimenu]="notifiMenu">
        <h2>Notifications Center <span>( 12 )</span></h2>
        <!-- <div class="notifi-item">

          <div class="text">
            <h4>Nottification Title</h4>
            <p>Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit amet, consectetur Lorem ipsum dolor sit
              amet, consectetur </p>
          </div>
        </div> -->


      </div>
    </div>

  </div>
</nav>
